import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'catering-orders',
            label: 'Catering Orders',
            routerLink: ['/extensions/sales/catering-orders'],
            icon: 'shopping-cart',
        },
        'sales',
    ),
];
